import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { Button, Grid, Typography } from "@material-ui/core";
import { debounce } from "throttle-debounce";
import InfoIcon from "@material-ui/icons/Info";
import { v4 } from "uuid";
import SearchIcon from "@material-ui/icons/Search";
import { GetApp as DownloadIcon } from "@material-ui/icons";
import useStyles, { CustomTextField } from "./styles";
import { translate as t } from "../../../../../../../infrastructure/translate/localization";

export default function StepHeader({
  title,
  tooltip,
  searchCallback,
  isLoading,
  actions,
  timeout,
}) {
  const [searchValue, setSearchValue] = useState();
  const {
    searchButton,
    searchContainer,
    tooltipIcon,
    tooltipContainer,
    searchIcon,
    downloadButton,
  } = useStyles();

  const handleCallback = useCallback(
    () =>
      debounce(timeout, false, (value) => {
        searchCallback(value);
      }),
    [searchCallback, timeout]
  );

  const handleSearch = (e) => {
    setSearchValue(e.target.value);
    handleCallback(e.target.value);
  };

  const handleSearchClick = () => {
    searchCallback(searchValue);
  };

  return (
    <Grid item container xs={12}>
      <Grid item container xs={actions.length < 1 ? 12 : 6}>
        <Typography variant="h5">{title}</Typography>
      </Grid>
      {actions.length > 0 && (
        <Grid xs={6} item container justify="flex-end">
          {actions.map(({ label, action }) => (
            <Button key={v4()} onClick={action} className={downloadButton}>
              <DownloadIcon />
              {label}
            </Button>
          ))}
        </Grid>
      )}
      {tooltip && (
        <Grid
          item
          xs={12}
          container
          alignItems="flex-start"
          className={tooltipContainer}
        >
          <InfoIcon className={tooltipIcon} />
          <Typography variant="body1">{tooltip}</Typography>
        </Grid>
      )}
      <Grid
        item
        container
        xs={12}
        className={searchContainer}
        alignItems="center"
      >
        {searchCallback && !isLoading && (
          <>
            <CustomTextField variant="outlined" onChange={handleSearch} />

            <Button
              className={searchButton}
              onClick={handleSearchClick}
              disabled={isLoading}
              startIcon={<SearchIcon className={searchIcon} />}
            >
              {t("actions.search")}
            </Button>
          </>
        )}
      </Grid>
    </Grid>
  );
}

StepHeader.defaultProps = {
  title: undefined,
  tooltip: undefined,
  searchCallback: undefined,
  actions: [],
  timeout: 1000,
  isLoading: false,
};

StepHeader.propTypes = {
  title: PropTypes.string,
  tooltip: PropTypes.string,
  searchCallback: PropTypes.func,
  actions: PropTypes.array,
  isLoading: PropTypes.bool,
  timeout: PropTypes.number,
};
